import { gql } from '@apollo/client';

export default gql`
  mutation UpdateTalentProfile(
    $talent_id: ID!
    $avatar: String
    $about: String
    $general_info: TalentGeneralInfoInput
    $account_info: TalentAccountVerificationInput
    $work_history: [WorkHistoryInput]
    $documents: [TalentDocumentInput]
    $skills: [ID]
    $available_now: Boolean
    $available_date: DateTimeUtc
    $hours_per_week: Int
    $companies: [ID]
    $account_settings: TalentAccountSettingsInput
    $currently_works_for_one_of_the_companies: Boolean
    $employee_name_who_referred: String
    $is_agree_to_terms_and_conditions: Boolean
    $is_bilingual: Boolean
    $languages: [TalentLanguageEnum]
    $marketing_source: TalentMarketingSourceEnum
    $work_type: [TalentWorkTypeEnum]
  ) {
    updateTalentProfile(
      talent_id: $talent_id
      currently_works_for_one_of_the_companies: $currently_works_for_one_of_the_companies
      avatar: $avatar
      about: $about
      general_info: $general_info
      account_info: $account_info
      work_history: $work_history
      documents: $documents
      skills: $skills
      available_now: $available_now
      available_date: $available_date
      hours_per_week: $hours_per_week
      companies: $companies
      account_settings: $account_settings
      employee_name_who_referred: $employee_name_who_referred
      is_agree_to_terms_and_conditions: $is_agree_to_terms_and_conditions
      is_bilingual: $is_bilingual
      languages: $languages
      marketing_source: $marketing_source
      work_type: $work_type
    )
  }
`;
